module.exports = __webpack_public_path__ + "media/applicants/icon-schedule@2x-50e20f56.png";